export default __webpack_public_path__ + "static/3-129bf4bf9ef8be93c3ffffbd6168a565.svg";